export enum CallDetailTabEnum {
    Transcript = 0,
    Comments = 1,
    Evaluation = 2,
    Outcome = 3,
    ParticipantHistory = 4,
    ConversationFlow = 5
}